import { createStore } from 'vuex'
import * as actions from './actions.js'
import * as mutations from './mutations.js'

export default createStore({
  state: {
    token: sessionStorage.getItem('token'),
    guestAddPopupView: false,
    messageSendPopupView: false,
    classInfoPopupView: false,
    messageSendListView: false,
    loading: false,
    name: sessionStorage.getItem('name'),
    // 로그인한 관리자 이름 — GET /admin/users/name 로 채움
    adminName: ''
  },
  getters: {
    logCheck(state) {
      return state.token !== ''
    }
  },
  mutations,
  actions,
  modules: {}
})
